module.exports = __webpack_public_path__ + "img/weingutloewenstein_5.a3c61a12.jpg";